import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { SUBJECT } from '../store/actionTypes';
import { Subject } from './models/subjects';

export const subject = createApi({
  reducerPath: SUBJECT,
  baseQuery,
  tagTypes: ['Subject'],
  endpoints: builder => ({
    getSubjects: builder.query<Subject[], { page: number; limit: number; curriculumId: string }>({
      query: variables => ({
        document: gql`
          query GetSubjects($curriculumId: String) {
            getSubjects(curriculumId: $curriculumId) {
              id
              name {
                language
                text
              }
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: any) => response?.getSubjects,
    }),
  }),
});

export const { useGetSubjectsQuery } = subject;
